"use client";

import dynamic from "next/dynamic";

const AISpeechClassifierV2 = dynamic(() => import("./AISpeechClassifierV2"));

export default AISpeechClassifierV2;
